export default __webpack_public_path__ + "static/fps+off@2x-4f92e93a396b0b37a3981b34027a1842.png";